import React, { ComponentType, ReactElement } from 'react';
import { EditorPlugin } from '@draft-js-plugins/editor';
import { EditorState } from 'draft-js';

// Components
import GifPickerDropdown, { GifPickerDropdownPubProps } from './GifPickerDropdown/GifPickerDropdown';
import GifComponent from './GifComponent/GifComponent';

export interface GifData {
  id: number;
  images: {
    fixed_width: {
      url: string;
    };
    original: {
      url: string;
    };
  };
}

export interface GifPluginStore {
  setEditorState?(editorState: EditorState): void;
  getEditorState?(): EditorState;
  getIsOpened(): boolean;
  setIsOpened(nextIsOpened: boolean): void;
}

export interface GifPluginConfig {
  GifPrefix?: string;
}

export default (
  // config variables coming in next phase of Gif plugin
  // eslint-disable-next-line
  config: GifPluginConfig = {}
): EditorPlugin & {
  GifPickerDropdown: ComponentType<GifPickerDropdownPubProps>;
} => {
  let isDropdownOpen = false;

  const store: GifPluginStore = {
    getEditorState: undefined,
    setEditorState: undefined,

    getIsOpened: () => isDropdownOpen,
    setIsOpened: nextIsOpened => {
      isDropdownOpen = nextIsOpened;
    },
  };

  const DecoratedGifPickerDropdown = (props: GifPickerDropdownPubProps): ReactElement => (
    <GifPickerDropdown {...props} store={store} />
  );

  return {
    blockRendererFn: (block, { getEditorState }) => {
      // 'gif-block' is legacy gif inserted in old draft editor
      if (block.getType() === 'atomic' || block.getType() === 'gif-block') {
        const contentState = getEditorState().getCurrentContent();
        const entity = block.getEntityAt(0);
        if (!entity) return null;
        const type = contentState.getEntity(entity).getType();
        if (type === 'GIF') {
          return {
            component: props => <GifComponent {...props} />,
            editable: false,
          };
        }
        return null;
      }

      return null;
    },
    GifPickerDropdown: DecoratedGifPickerDropdown,
    initialize: ({ getEditorState, setEditorState }) => {
      store.getEditorState = getEditorState;
      store.setEditorState = setEditorState;
    },
  };
};
